import { CXContainerableBlock } from '~/components/ClientExperience/OneFlow/models/cx-containerable-block.model';
import type { CXInvoiceServiceItemBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-service-item-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { IServicesBlockResponse } from '~/types/server.types';

export class CXServicesBlock extends CXContainerableBlock {
    type: 'services_block';

    constructor(
        block: IServicesBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    get childBlocks() {
        return super.childBlocks as CXInvoiceServiceItemBlock[];
    }
}
